import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../common-styles.css';
import './ContactUsPage.css';
import ContactSection from '../HomePage/ContactSection';

const ContactUsPage: React.FC = () => {
  return (
    <div className="contact-us-page">
      <section className="contact-page-hero gradient-hero contact-hero-overrides">
        <Container>
          <div className="back-link-wrapper text-start mb-3">
            <Link to="/" className="back-link"><span>&larr; Back</span></Link>
          </div>
          <h1 className="contact-page-title"> Crafting Connections. Creating Legacy.</h1>
          {/* Reuse existing contact section exactly */}
          <div className="contact-standalone-wrapper">
            <ContactSection showHeading={false} />
          </div>
        </Container>
      </section>
    </div>
  );
};

export default ContactUsPage;
